import { useRef } from 'react';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 CÓDIGO DE VERIFICACIÓN

    Casillas separadas, una por dígito. Resuelve lo que siempre falla
    en estos campos:

      · pegar el código completo lo reparte solo
      · Backspace en una casilla vacía salta a la anterior
      · las flechas mueven entre casillas
      · en móvil abre el teclado numérico

    Te sirve para el confirmBulkHardDelete de tu helper de swal.
*/

export const FieldOtp = ({
    id, name, label, hint, error,
    value = '', onChange,
    length = 6, isDisabled = false, span = 1,
}) => {

    const REF__useRefs = useRef([]);

    const CHARS = String(value).padEnd(length, ' ').slice(0, length).split('');

    const onSet = (next) => onChange?.(next.replace(/\s/g, ''));

    const onWrite = (index) => (event) => {
        const RAW = event.target.value.replace(/\D/g, '');

        if (!RAW) {
            const NEXT = CHARS.map((c, i) => (i === index ? ' ' : c)).join('');
            return onSet(NEXT);
        }

        // Pegar el código completo: se reparte en todas las casillas
        if (RAW.length > 1) {
            const NEXT = RAW.slice(0, length).padEnd(length, ' ');
            onSet(NEXT);
            REF__useRefs.current[Math.min(RAW.length, length - 1)]?.focus();
            return;
        }

        const NEXT = CHARS.map((c, i) => (i === index ? RAW : c)).join('');
        onSet(NEXT);
        REF__useRefs.current[index + 1]?.focus();
    };

    const onKeyDown = (index) => (event) => {

        if (event.key === 'Backspace' && !CHARS[index].trim()) {
            REF__useRefs.current[index - 1]?.focus();
        }

        if (event.key === 'ArrowLeft') REF__useRefs.current[index - 1]?.focus();
        if (event.key === 'ArrowRight') REF__useRefs.current[index + 1]?.focus();
    };

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__otp`}>
                {
                    CHARS.map((char, index) => (
                        <input name={DOM_NAME} autoComplete="nope" data-lpignore="true" data-1p-ignore="true" data-form-type="other" spellCheck={false} autoCorrect="off" autoCapitalize="off" key={index} type="text" inputMode="numeric"
                            ref={(el) => { REF__useRefs.current[index] = el; }}
                            id={index === 0 ? id : undefined}
                            name={index === 0 ? (name ?? id) : undefined}
                            className={`${BLOCK}__otp_box`}
                            value={char.trim()} maxLength={length}
                            onChange={onWrite(index)} onKeyDown={onKeyDown(index)}
                            onFocus={(event) => event.target.select()}
                            disabled={isDisabled} autoComplete="one-time-code"
                            aria-label={`Dígito ${index + 1}`} />
                    ))
                }
            </div>

        </FieldShell>
    );
};
